'use strict';

function ctrl($stateProvider) {
    $stateProvider
        .state('auth.login', {
            url: '/login',
            template: require('../views/login.html'),
            controller: 'LoginCtrl',
            controllerAs: 'login'
        })
        .state('auth.twoStep', {
            url: '/2step',
            template: require('../views/2step.html'),
            controller: 'twoStep',
            controllerAs: 'twostep'
        })
        .state('auth.setpassword', {
            url: '/setpass',
            template: require('../views/setpass.html'),
            controller: 'setPassword',
            controllerAs: 'setpassword'
        })
        .state('auth.forgot', {
            url: '/forgot-pass',
            template: require('../views/forgot-pass.html'),
            controller: 'forgotPass',
            controllerAs: 'forgotpass'
        })
}

ctrl.$inject = ['$stateProvider'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/auth/routes/auth.js
 **/